import { useRef, useState } from "react";
import { Delete } from "@mui/icons-material";
import React from "react";
import { createPortal } from "react-dom";
import "./DeleteConfirmModal.scss";
import { Spinner } from "react-bootstrap";
import { useAnchoredPortalPosition } from "./useAnchoredPortalPosition";

const MODAL_WIDTH_PX = 270;
const MODAL_HEIGHT_ESTIMATE_PX = 140;

interface DeleteConfirmModalProps {
  onConfirm: () => void;
  title?: string;
  text?: string;
  isLoading?: boolean;
  showActionButton?: boolean;
}

export default function DeleteConfirmModal({
  text,
  onConfirm,
  title,
  isLoading,
  showActionButton = true,
}: DeleteConfirmModalProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const anchorRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const pos = useAnchoredPortalPosition(
    isOpen,
    anchorRef,
    contentRef,
    MODAL_WIDTH_PX,
    MODAL_HEIGHT_ESTIMATE_PX
  );

  return (
    <div className="delete-confirm-container">
      <div
        ref={anchorRef}
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "14px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        <Delete style={{ fontSize: "17px" }} />

        <span style={{ marginLeft: "5px", marginTop: "2px" }}>
          {text ? text : ""}
        </span>
      </div>

      {isOpen &&
        pos &&
        createPortal(
          <div
            ref={contentRef}
            className="delete-confirm-modal delete-confirm-modal--portal-root"
            style={{
              top: pos.top,
              left: pos.left,
              width: MODAL_WIDTH_PX,
            }}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            <span
              className="delete-confirm-heading"
              dangerouslySetInnerHTML={{
                __html: title ? title : "Are you sure you want to delete this?",
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px",
              }}
            >
              {showActionButton && (
                <button
                  className="delete-confirm-delete"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    onConfirm();
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {isLoading && (
                    <Spinner
                      style={{ marginRight: "5px" }}
                      animation="border"
                      size="sm"
                    />
                  )}
                  Delete
                </button>
              )}

              <button
                className="delete-confirm-cancel"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
}
